export const SYMPTOM_OPTIONS = [
  { value: "RASH", label: "Rash" },
  { value: "NAUSEA", label: "Nausea" },
  { value: "ANAPHYLAXIS", label: "Anaphylaxis" },
  { value: "UNKNOWN", label: "Unknown" },
];

export const DEFAULT_VALUES = {
  activeTab: "ALLERGY",
  name: "",
  allergyReaction: "RASH",
  serious: false,
  drugName: "",
  drugGenericName: "",
  ingredients: "",
  note: null,
};
